<script setup lang="ts">
import { ARBITRATION_STATUS, ARBITRATION_STATUS_LABELS } from '@/constants/arbitrationStatus'

defineProps(['params'])
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <div class="w-fit">
      <span
        :class="{
          'badge bg-blue-100': params.data.status === ARBITRATION_STATUS.PENDING,
          'badge bg-emerald-100': params.data.status === ARBITRATION_STATUS.APPROVED,
          'badge bg-red-100': params.data.status === ARBITRATION_STATUS.REJECTED,
        }"
      >
        {{ ARBITRATION_STATUS_LABELS[params.data.status as keyof typeof ARBITRATION_STATUS_LABELS] || params.data.status }}
      </span>
    </div>
  </div>
</template>
